<template>
  <div class="cart-empty" :class="{ 'cart-empty--dark': $vuetify.theme.dark }">
    <span class="cart-empty__icon">
      <v-icon size="34" color="rgba(91, 57, 201, 0.45)"
        >fal fa-shopping-cart</v-icon
      >
    </span>
    <div class="cart-empty__text">
      <p class="cart-empty__title">{{ $t("cart_empty") }}</p>
      <p class="cart-empty__hint">{{ $t("cart_empty_description") }}</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
/* PosSmart v2 empty cart state */
.cart-empty {
  height: 100%;
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 24px;
  text-align: center;
}

.cart-empty__icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #f3f0fc; /* brand-soft */
  border: 2px dashed rgba(91, 57, 201, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.cart-empty--dark {
  background: #171b21;
}

.cart-empty--dark .cart-empty__icon {
  background: rgba(91, 57, 201, 0.15);
  border-color: rgba(196, 181, 253, 0.4);
}

.cart-empty--dark .cart-empty__title {
  color: #94a3b8;
}

.cart-empty--dark .cart-empty__hint {
  color: #64748b;
}

.cart-empty__title {
  font-size: 14px;
  font-weight: 900;
  color: #64748b; /* slate-500 */
  margin: 0;
}

.cart-empty__hint {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8; /* slate-400 */
  margin: 2px 0 0;
}
</style>
